import { registerFeature } from '../operationRegistry';
import { api } from '../../api';

export function registerCompareOperations(): void {
  registerFeature({
    name: 'compare',
    invalidateKeys: [['compare-items']],
    operations: [
      {
        type: 'COMPARE_TOGGLE',
        collapseRule: 'cancelPair',
        cancelPairType: 'COMPARE_TOGGLE',
        collapseKeyFn: (p) => `cmp:${p.productId}`,
        async execute(payload) {
          await api('/compare-items/toggle', {
            method: 'POST',
            body: JSON.stringify({ product_id: payload.productId }),
          });
          return undefined;
        },
      },
      {
        type: 'COMPARE_CLEAR',
        collapseRule: 'lastWins',
        collapseKeyFn: () => 'cmp:clear',
        async execute() {
          await api('/compare-items', { method: 'DELETE' });
          return undefined;
        },
      },
    ],
  });
}
